import React from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useSectionVisibility } from "@/hooks/useSectionVisibility";
import { useToast } from "@/components/ui/use-toast";
import { Eye, EyeOff } from "lucide-react";

export const SectionVisibilityToggle = () => {
  const { sections, isLoading, toggleVisibility } = useSectionVisibility();
  const { toast } = useToast();

  const handleToggle = async (sectionKey: string, currentVisibility: boolean) => {
    try {
      await toggleVisibility.mutateAsync({
        sectionKey,
        isVisible: !currentVisibility,
      });
      toast({
        title: !currentVisibility ? "Sektion eingeblendet" : "Sektion ausgeblendet",
        description: `Die Sektion wurde ${!currentVisibility ? "eingeblendet" : "ausgeblendet"}.`,
      });
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Fehler",
        description: "Sichtbarkeit konnte nicht geändert werden.",
      });
    }
  };

  if (isLoading) {
    return (
      <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
        <p className="text-white text-sm">Lade Sektionen...</p>
      </div>
    );
  }

  return (
    <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20 space-y-4">
      <h3 className="text-white font-semibold text-lg flex items-center gap-2">
        <Eye className="w-5 h-5" />
        Sektionen Ein-/Ausblenden
      </h3>
      <div className="space-y-3">
        {sections?.map((section) => (
          <div
            key={section.id}
            className="flex items-center justify-between py-2 px-3 bg-white/5 rounded-lg"
          >
            <Label
              htmlFor={`toggle-${section.section_key}`}
              className="text-white text-sm cursor-pointer flex items-center gap-2"
            >
              {section.is_visible ? (
                <Eye className="w-4 h-4 text-green-400" />
              ) : (
                <EyeOff className="w-4 h-4 text-gray-400" />
              )}
              {section.section_name}
            </Label>
            <Switch
              id={`toggle-${section.section_key}`}
              checked={section.is_visible}
              onCheckedChange={() => handleToggle(section.section_key, section.is_visible)}
              disabled={toggleVisibility.isPending}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
